"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclaimerLine = void 0;
const react_1 = __importDefault(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const styled_1 = require("./styled");
const text_custom_1 = require("../../text-custom");
const DisclaimerLine = props => {
    const { number, description, colorInherit } = props;
    return (react_1.default.createElement(styled_1.StyledDisclaimerDataContainer, { className: "disclaimer-text-wrapper" },
        react_1.default.createElement(styled_1.StyledDisclaimerKey, { className: "disclaimer-text-key" },
            react_1.default.createElement(text_custom_1.TextCustom, { appearance: components_core_1.TokenTextAppearance.copy200, style: {
                    color: colorInherit ? components_core_1.TokenTextColor.inherit : components_core_1.TokenTextColor.secondary
                } }, `${number}.`)),
        react_1.default.createElement(styled_1.StyledDisclaimerText, { className: "disclaimer-text-data" },
            react_1.default.createElement(text_custom_1.TextCustom, { appearance: components_core_1.TokenTextAppearance.copy200, style: {
                    color: colorInherit ? components_core_1.TokenTextColor.inherit : components_core_1.TokenTextColor.secondary
                } }, description))));
};
exports.DisclaimerLine = DisclaimerLine;
